

import CrossSell from '~/components/CrossSell/CrossSell';

export default {
    components: {
        CrossSell
    },
    props: {
        items: {
            type: Array,
            required: true,
            default: () => []
        },
        participants: {
            type: Array,
            required: true,
            default: () => []
        }
    }
};
